(function () {
  "use strict";

  function ready(callback) {
    if (document.readyState !== "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }

  ready(function () {
    document.dispatchEvent(new CustomEvent("page:loaded"));
  });

  function addPrintStudioFilterStyles() {
    if (document.getElementById("print-studio-size-filter-styles")) return;
    var style = document.createElement("style");
    style.id = "print-studio-size-filter-styles";
    style.textContent = ".print-studio__size-help{margin:0 0 12px;color:var(--muted);line-height:1.45}.print-studio__size-filters{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:10px;margin-bottom:12px}.print-studio__size-count{margin:0 0 12px;color:var(--muted);font-size:.9rem;font-weight:800}.print-studio__filter{position:relative;display:grid;align-content:start;gap:6px;min-height:92px;padding:13px;border:1px solid var(--line);background:#fff;cursor:pointer}.print-studio__filter.is-disabled{opacity:.45;cursor:not-allowed}.print-studio__filter input{position:absolute;opacity:0}.print-studio__popular-badge{display:inline-flex;align-items:center;width:max-content;padding:4px 7px;border-radius:999px;background:#fff1cf;color:#765000;font-size:.68rem;font-style:normal;font-weight:950;line-height:1;text-transform:uppercase;letter-spacing:0}.print-studio__art{background-color:#f7f3e9;background-image:linear-gradient(45deg,rgba(34,91,111,.08) 25%,transparent 25%),linear-gradient(-45deg,rgba(34,91,111,.08) 25%,transparent 25%),linear-gradient(45deg,transparent 75%,rgba(34,91,111,.08) 75%),linear-gradient(-45deg,transparent 75%,rgba(34,91,111,.08) 75%);background-position:0 0,0 9px,9px -9px,-9px 0;background-size:18px 18px}.print-studio__art img{object-fit:contain!important;background:#fff}.print-studio__fit-note{margin:0;color:var(--ink);font-size:.92rem;line-height:1.45}.print-studio__fit-note strong{display:block;margin-bottom:2px}.print-studio__fit-badge{display:inline-flex;align-items:center;width:max-content;margin-top:7px;padding:4px 7px;border-radius:999px;background:#ece8dd;color:#34322e;font-size:.72rem;font-style:normal;font-weight:900;line-height:1}.print-studio__size.is-fit-best .print-studio__fit-badge{background:#dff0e2;color:#1c5d31}.print-studio__size.is-fit-close .print-studio__fit-badge{background:#fff1cf;color:#765000}.print-studio__size.is-fit-space .print-studio__fit-badge{background:#f8dfd8;color:#8a321c}@media(max-width:920px){.print-studio__size-filters{grid-template-columns:repeat(2,minmax(0,1fr))}}@media(max-width:640px){.print-studio__size-filters{grid-template-columns:1fr}}";
    document.head.appendChild(style);
  }

  var fineArtMaterialKeys = {
    "fine-art": true,
    "fine-art-smooth": true,
    "fine-art-textured": true,
    "fine-art-stock": true
  };

  function studioText(studio, key, fallback) {
    return studio && typeof studio.t === "function" ? studio.t(key, fallback) : fallback;
  }

  function studioHasVariants(studio, variants) {
    return studio && typeof studio.hasVariants === "function" ? studio.hasVariants(variants) : Array.isArray(variants) && variants.length > 0;
  }

  function ensureFineArtMaterials(studio) {
    if (!studio) return;
    if (!Array.isArray(studio.materials)) studio.materials = [];
    var products = studio.products || {};
    var materials = [];

    if (studioHasVariants(studio, products.fineArt)) {
      materials.push({
        key: "fine-art-smooth",
        type: "fine-art",
        paperFinish: studioText(studio, "fineArtSmoothLabel", "Smooth"),
        label: studioText(studio, "fineArtSmoothMaterialLabel", "Smooth fine art paper"),
        note: studioText(studio, "fineArtSmoothNote", "Clean archival paper surface"),
        variants: products.fineArt
      });
    }

    if (studioHasVariants(studio, products.fineArtTextured)) {
      materials.push({
        key: "fine-art-textured",
        type: "fine-art",
        paperFinish: studioText(studio, "fineArtTexturedLabel", "Textured"),
        label: studioText(studio, "fineArtTexturedMaterialLabel", "Textured fine art paper"),
        note: studioText(studio, "fineArtTexturedNote", "Watercolour-style tooth and texture"),
        variants: products.fineArtTextured
      });
    }

    if (studioHasVariants(studio, products.fineArtStockFrame)) {
      materials.push({
        key: "fine-art-stock",
        type: "fine-art",
        stockOnly: true,
        label: studioText(studio, "fineArtLabel", "Fine art paper"),
        note: studioText(studio, "fineArtNote", "Archival paper for editions"),
        variants: []
      });
    }

    studio.materials = studio.materials.filter(function (material) {
      return !(material && fineArtMaterialKeys[material.key]);
    });
    if (!materials.length) return;

    var photoIndex = studio.materials.findIndex(function (material) {
      return material && material.key === "photo";
    });
    studio.materials.splice.apply(studio.materials, [photoIndex >= 0 ? photoIndex + 1 : 0, 0].concat(materials));
  }

  function routeHasMaterial(studio, material, route) {
    if (!studio || !material) return false;
    var products = studio.products || {};
    if (route === "paper-only") {
      if (material.type === "photo") return studioHasVariants(studio, material.variants);
      if (material.type === "fine-art") return !material.stockOnly && studioHasVariants(studio, material.variants);
    }
    if (route === "stock") {
      if (material.type === "photo") return studioHasVariants(studio, products.stockFrame);
      if (material.type === "fine-art") return !!material.stockOnly && studioHasVariants(studio, products.fineArtStockFrame);
    }
    if (route === "canvas-only") return material.type === "canvas" && studioHasVariants(studio, material.variants);
    if (route === "floater") return material.type === "canvas" && studioHasVariants(studio, products[material.floaterKey]);
    return false;
  }

  function patchPrintStudio() {
    if (!window.customElements) return;
    var Studio = customElements.get("print-frame-studio");
    if (!Studio) return;

    var proto = Studio.prototype;
    patchFineArtMaterialRepair(proto);
    if (proto.__artFitPatched) {
      refreshFineArtMaterials();
      return;
    }

    proto.__sizeFilterPatched = true;
    proto.__artFitPatched = true;
    var originalUpdatePreview = proto.updatePreview;

    proto.sizeFilterDefinitions = function () {
      return [
        { key: "paper-only", label: "Paper print only", note: "Photo and fine art paper prints without a frame" },
        { key: "stock", label: "Paper print + stock frame", note: "Paper sizes that fit ready-made frames", badge: "Most Popular" },
        { key: "canvas-only", label: "Canvas only", note: "Wrapped canvas prints without a floater frame" },
        { key: "floater", label: "Canvas + floater frame", note: "Canvas sizes that can pair with floater frames", badge: "Most Popular" }
      ];
    };

    proto.sizeFilterHasProducts = function (key) {
      this.ensureFineArtMaterial();
      if (key === "paper-only") return this.materials.some(function (material) { return (material.type === "photo" || material.type === "fine-art") && this.hasVariants(material.variants); }, this);
      if (key === "stock") return this.hasVariants(this.products.stockFrame) || this.hasVariants(this.products.fineArtStockFrame);
      if (key === "canvas-only") return this.materials.some(function (material) { return material.type === "canvas" && this.hasVariants(material.variants); }, this);
      if (key === "floater") return this.hasVariants(this.products.matteFloater) || this.hasVariants(this.products.satinFloater);
      return false;
    };

    proto.hasRouteVariants = function (material, route) {
      return routeHasMaterial(this, material, route);
    };

    proto.materialCompatible = function (material) {
      return this.hasRouteVariants(material, this.sizeFilter);
    };

    proto.compatibleMaterials = function () {
      this.ensureFineArtMaterial();
      var list = this.materials.filter(function (material) { return this.materialCompatible(material); }, this);
      return list.length ? list : this.materials;
    };

    proto.ensureFineArtMaterial = function () {
      ensureFineArtMaterials(this);
    };

    proto.defaultFrameMode = function () {
      if (this.sizeFilter === "stock") return "stock";
      if (this.sizeFilter === "floater") return "floater";
      if (this.sizeFilter === "canvas-only") return "canvas-only";
      return "none";
    };

    proto.applySizeFilterDefaults = function () {
      this.ensureFineArtMaterial();
      if (this.sizeFilter === "print-only") this.sizeFilter = "paper-only";
      if (!this.sizeFilterHasProducts(this.sizeFilter)) {
        var first = this.sizeFilterDefinitions().find(function (filter) { return this.sizeFilterHasProducts(filter.key); }, this);
        this.sizeFilter = first ? first.key : "paper-only";
      }
      if (!this.materialCompatible(this.material)) this.material = this.compatibleMaterials()[0] || this.materials[0];
      this.frameMode = this.defaultFrameMode();
      this.paperFinish = this.defaultPaperFinish();
      var colours = this.frameColours();
      if (colours.length && !colours.includes(this.frameColour)) this.frameColour = colours[0];
    };

    proto.frameModes = function () {
      if (this.sizeFilter === "stock") return [{ key: "stock", label: "Stock frame", note: "Black, white, or oak frame" }];
      if (this.sizeFilter === "floater") return [{ key: "floater", label: "Floater frame", note: "Black, oak, or gold floater frame" }];
      if (this.sizeFilter === "canvas-only") return [{ key: "canvas-only", label: "Canvas print only", note: "Choose the canvas depth for production" }];
      if (this.material.type === "photo") return [{ key: "none", label: "No frame", note: "Print only, no frame details added" }];
      if (this.material.type === "fine-art") return [{ key: "none", label: "No frame", note: "Fine art paper print only" }];
      return [{ key: "none", label: "No frame", note: "Print only" }];
    };

    proto.renderMaterials = function () {
      this.applySizeFilterDefaults();
      this.materialsEl.innerHTML = "";
      this.compatibleMaterials().forEach(function (material) {
        var picked = this.material && this.material.key === material.key;
        var label = document.createElement("label");
        label.className = "print-studio__choice" + (picked ? " is-picked" : "");
        label.innerHTML = '<input type="radio" name="studio_material" ' + (picked ? "checked" : "") + "><strong>" + material.label + "</strong><small>" + material.note + "</small>";
        label.addEventListener("click", function () {
          var previousSize = this.size;
          this.material = material;
          this.paperFinish = this.defaultPaperFinish();
          this.frameMode = this.defaultFrameMode();
          this.size = previousSize && this.sizes().includes(previousSize) ? previousSize : "";
          this.pick(this.materialsEl, label);
          this.renderSizes();
          this.renderFinishOptions();
          this.sync();
        }.bind(this));
        this.materialsEl.append(label);
      }, this);
    };

    proto.renderSizeFilters = function () {
      if (!this.sizeFiltersEl) return;
      this.sizeFiltersEl.innerHTML = "";
      var filters = this.sizeFilterDefinitions();
      if (this.sizeFilter === "print-only") this.sizeFilter = "paper-only";
      if (!filters.some(function (filter) { return filter.key === this.sizeFilter && this.sizeFilterHasProducts(filter.key); }, this)) {
        var first = filters.find(function (filter) { return this.sizeFilterHasProducts(filter.key); }, this);
        this.sizeFilter = first ? first.key : "paper-only";
      }
      filters.forEach(function (filter) {
        var available = this.sizeFilterHasProducts(filter.key);
        var picked = filter.key === this.sizeFilter;
        var label = document.createElement("label");
        label.className = "print-studio__filter" + (picked ? " is-picked" : "") + (available ? "" : " is-disabled");
        label.innerHTML = '<input type="radio" name="studio_size_filter" ' + (picked ? "checked" : "") + " " + (available ? "" : "disabled") + "><strong>" + filter.label + "</strong>" + (filter.badge ? '<em class="print-studio__popular-badge">' + filter.badge + "</em>" : "") + "<small>" + filter.note + "</small>";
        if (available) {
          label.addEventListener("click", function () {
            this.sizeFilter = filter.key;
            this.size = "";
            this.applySizeFilterDefaults();
            this.renderSizeFilters();
            this.renderMaterials();
            this.renderSizes();
            this.renderFinishOptions();
            this.sync();
          }.bind(this));
        }
        this.sizeFiltersEl.append(label);
      }, this);
    };

    proto.renderSizes = function () {
      this.sizesEl.innerHTML = "";
      var sizes = this.sizes();
      var selected = sizes.includes(this.size) ? this.size : sizes[0] || "";
      sizes.forEach(function (size) {
        var picked = size === selected;
        var fit = this.fitInfoForSize(size);
        var fitMarkup = this.artRatio ? '<em class="print-studio__fit-badge">' + fit.label + "</em>" : "";
        var label = document.createElement("label");
        label.className = "print-studio__size" + (picked ? " is-picked" : "") + (this.artRatio ? " is-fit-" + fit.key : "");
        label.innerHTML = '<input type="radio" name="studio_size" ' + (picked ? "checked" : "") + "><strong>" + size + "</strong><small>" + this.moneyFor(size) + "</small>" + fitMarkup;
        label.addEventListener("click", function () {
          this.size = size;
          this.pick(this.sizesEl, label);
          this.sync();
        }.bind(this));
        this.sizesEl.append(label);
        if (picked) this.size = size;
      }, this);
      if (!sizes.length) this.size = "";
      this.updateSizeFilterCopy();
      this.updateFitCopy();
    };

    proto.renderPaperFinishes = function () {
      var el = this.querySelector("[data-paper-finishes]");
      if (!el) return;
      el.innerHTML = "";
      var options = this.paperFinishOptions();
      if (!options.length) {
        this.paperFinish = "";
        return;
      }
      if (!options.some(function (option) { return option.label === this.paperFinish; }, this)) {
        this.paperFinish = options[0].label;
      }
      options.forEach(function (option) {
        var label = this.modeLabel("studio_paper_finish", option.label, option.note, option.label === this.paperFinish);
        label.addEventListener("click", function () {
          var previousSize = this.size;
          this.paperFinish = option.label;
          this.size = previousSize;
          this.pick(el, label);
          this.renderSizes();
          this.sync();
        }.bind(this));
        el.append(label);
      }, this);
    };

    proto.paperFinishOptions = function () {
      if (this.material && this.material.paperFinish) return [{ label: this.material.paperFinish, note: this.material.note || this.material.label }];
      if (this.material && this.material.stockOnly) return [];
      if (this.material && this.material.type === "photo") return [
        { label: this.t("photoLustreLabel", "Lustre"), note: this.t("photoLustreNote", "Popular photo finish") },
        { label: this.t("photoMatteLabel", "Matte"), note: this.t("photoMatteNote", "Low-glare photo finish") }
      ];
      if (this.material && this.material.type === "fine-art") return [
        { label: this.t("fineArtSmoothLabel", "Smooth"), note: this.t("fineArtSmoothNote", "Clean archival paper surface") },
        { label: this.t("fineArtTexturedLabel", "Textured"), note: this.t("fineArtTexturedNote", "Watercolour-style tooth and texture") }
      ];
      return [];
    };

    proto.variantOptionValues = function (variant) {
      return [variant.option1, variant.option2, variant.option3].filter(Boolean).map(function (option) {
        return String(option).trim();
      });
    };

    proto.variantHasOption = function (variant, value) {
      var selected = String(value || "").trim().toLowerCase();
      if (!selected) return true;
      return this.variantOptionValues(variant).some(function (option) {
        var normalized = option.toLowerCase();
        return normalized === selected || normalized.includes(selected) || selected.includes(normalized);
      });
    };

    proto.stockFrameColourVariantMatches = function (variant) {
      if (!this.isStockFramePaper()) return true;
      return this.variantHasOption(variant, this.frameColour);
    };

    proto.variantUsesPaperFinish = function (variant) {
      var finishes = this.paperFinishOptions().map(function (option) {
        return String(option.label || "").trim().toLowerCase();
      }).filter(Boolean);
      if (!finishes.length) return false;

      return this.variantOptionValues(variant).some(function (value) {
        var normalized = value.toLowerCase();
        return finishes.some(function (finish) {
          return normalized === finish || normalized.includes(finish) || finish.includes(normalized);
        });
      });
    };

    proto.paperFinishVariantMatches = function (variant) {
      if (!this.material) return true;
      if (this.material.type !== "photo" && this.material.type !== "fine-art") return true;
      var selected = String(this.paperFinish || "").toLowerCase();
      if (!selected) return true;
      if (!this.variantUsesPaperFinish(variant)) return true;
      return this.variantHasOption(variant, selected);
    };

    proto.variant = function () {
      if (!this.material || !this.size) return null;
      return this.sourceVariants().find(function (variant) {
        var sameSize = this.sizeOf(variant).toLowerCase() === this.size.toLowerCase();
        var sameColour = this.stockFrameColourVariantMatches(variant);
        var samePaperFinish = this.paperFinishVariantMatches(variant);
        return sameSize && sameColour && samePaperFinish && variant.available !== false;
      }, this);
    };

    proto.sizeRatioNumber = function (size) {
      var parts = String(size || "").toLowerCase().split("x").map(function (part) { return Number(part.trim()); });
      if (parts.length !== 2 || !parts[0] || !parts[1]) return 0;
      return parts[0] / parts[1];
    };

    proto.reduceRatio = function (width, height) {
      var a = Math.round(width || 0);
      var b = Math.round(height || 0);
      if (!a || !b) return "";
      var x = a;
      var y = b;
      while (y) {
        var next = x % y;
        x = y;
        y = next;
      }
      return Math.round(a / x) + ":" + Math.round(b / x);
    };

    proto.fitInfoForSize = function (size) {
      if (!this.artRatio) return { key: "unknown", label: "", detail: "Upload artwork to see which sizes match its shape." };
      var boxRatio = this.sizeRatioNumber(size);
      if (!boxRatio) return { key: "unknown", label: "", detail: "Choose a size to check the artwork fit." };
      var delta = Math.abs(Math.log(this.artRatio / boxRatio));
      var space = this.artRatio < boxRatio ? "space on the sides" : "space above and below";
      if (delta <= 0.02) return { key: "best", label: "Best fit", detail: "The artwork shape matches this size." };
      if (delta <= 0.08) return { key: "close", label: "Close fit", detail: "The artwork will fit with minor " + space + "." };
      return { key: "space", label: "Shows space", detail: "The full artwork will fit inside the selected size, with visible " + space + "." };
    };

    proto.updateFitCopy = function () {
      var note = this.fitNoteEl || this.querySelector("[data-fit-note]");
      if (!note) return;
      this.fitNoteEl = note;
      if (!this.artRatio) {
        note.innerHTML = "<strong>Artwork fit</strong>Upload an image and the sizes will show whether the shape is a clean match or will leave space.";
        return;
      }
      var shape = this.reduceRatio(this.artNaturalWidth, this.artNaturalHeight) || "detected";
      var fit = this.fitInfoForSize(this.size);
      note.innerHTML = "<strong>Artwork shape: " + shape + "</strong>" + fit.detail;
    };

    proto.installArtworkFit = function () {
      addPrintStudioFilterStyles();
      this.fitNoteEl = this.querySelector("[data-fit-note]");
      if (!this.fitNoteEl) {
        var controls = this.querySelector(".print-studio__preview-controls");
        if (controls) {
          var note = document.createElement("p");
          note.className = "print-studio__fit-note";
          note.setAttribute("data-fit-note", "");
          controls.append(note);
          this.fitNoteEl = note;
        }
      }
      this.updateFitCopy();
    };

    proto.updatePreview = function () {
      if (originalUpdatePreview) originalUpdatePreview.call(this);
      var frame = this.querySelector("[data-frame]");
      var canvasOnly = this.material && this.material.type === "canvas" && this.frameMode === "canvas-only";
      if (frame && canvasOnly) {
        frame.classList.add("is-print-only");
        frame.classList.remove("is-canvas-only");
        this.style.setProperty("--mat", "0px");
      }
      var art = this.querySelector("[data-art]");
      if (art && this.artRatio) {
        var fit = this.fitInfoForSize(this.size);
        art.classList.toggle("is-fit-best", fit.key === "best");
        art.classList.toggle("is-fit-close", fit.key === "close");
        art.classList.toggle("is-fit-space", fit.key === "space");
      }
      this.updateFitCopy();
    };

    proto.preview = function (event) {
      var file = event.target.files && event.target.files[0];
      if (!file) return;
      if (!file.type || file.type.includes("tiff")) {
        this.artRatio = 0;
        this.artNaturalWidth = 0;
        this.artNaturalHeight = 0;
        this.renderSizes();
        this.updateFitCopy();
        this.querySelector("[data-status]").textContent = "TIFF files are attached for production, but most browsers cannot preview them here.";
        return;
      }
      var reader = new FileReader();
      reader.onload = function () {
        var source = reader.result;
        var image = new Image();
        image.onload = function () {
          this.artRatio = image.naturalWidth / image.naturalHeight;
          this.artNaturalWidth = image.naturalWidth;
          this.artNaturalHeight = image.naturalHeight;
          this.querySelector("[data-art-image]").src = source;
          this.querySelector("[data-art]").classList.add("has-image");
          this.renderSizes();
          this.updatePreview();
          this.sync();
        }.bind(this);
        image.onerror = function () {
          this.querySelector("[data-art-image]").src = source;
          this.querySelector("[data-art]").classList.add("has-image");
          this.updateFitCopy();
        }.bind(this);
        image.src = source;
      }.bind(this);
      reader.readAsDataURL(file);
    };

    proto.updateSizeFilterCopy = function () {
      if (!this.sizeCountEl) return;
      var filter = this.sizeFilterDefinitions().find(function (item) { return item.key === this.sizeFilter; }, this);
      var label = filter ? filter.label.toLowerCase() : "selected";
      var count = this.sizes().length;
      var material = this.material ? this.material.label : "selected material";
      this.sizeCountEl.textContent = count ? "Showing " + count + " " + label + " size" + (count === 1 ? "" : "s") + " for " + material + "." : "No sizes are available for this route yet.";
    };

    proto.installSizeFilter = function () {
      var panel = this.querySelector('[data-step="2"]');
      if (!panel || !this.sizesEl) return;
      addPrintStudioFilterStyles();
      this.installArtworkFit();
      this.ensureFineArtMaterial();
      this.sizeFilter = this.sizeFilter === "print-only" ? "paper-only" : (this.sizeFilter || "paper-only");
      this.sizeFiltersEl = this.querySelector("[data-size-filters]");
      this.sizeCountEl = this.querySelector("[data-size-count]");
      if (!this.sizeFiltersEl) {
        var help = document.createElement("p");
        help.className = "print-studio__size-help";
        help.textContent = "Pick the production path first so the builder only shows sizes and materials that fit that kind of order.";
        var filters = document.createElement("div");
        filters.className = "print-studio__size-filters";
        filters.setAttribute("data-size-filters", "");
        var count = document.createElement("p");
        count.className = "print-studio__size-count";
        count.setAttribute("data-size-count", "");
        panel.insertBefore(help, this.sizesEl);
        panel.insertBefore(filters, this.sizesEl);
        panel.insertBefore(count, this.sizesEl);
        this.sizeFiltersEl = filters;
        this.sizeCountEl = count;
      }
      this.applySizeFilterDefaults();
      this.renderSizeFilters();
      this.renderMaterials();
      this.renderSizes();
      this.renderFinishOptions();
      this.sync();
    };
  }

  function patchFineArtMaterialRepair(proto) {
    if (!proto || proto.__fineArtMaterialRepairPatched) return;

    var originalCompatibleMaterials = proto.compatibleMaterials;
    var originalApplySizeFilterDefaults = proto.applySizeFilterDefaults;
    var originalInstallSizeFilter = proto.installSizeFilter;
    var originalRenderMaterials = proto.renderMaterials;
    var originalPaperFinishOptions = proto.paperFinishOptions;

    proto.__fineArtMaterialRepairPatched = true;
    proto.ensureFineArtMaterial = function () {
      ensureFineArtMaterials(this);
    };

    proto.hasRouteVariants = function (material, route) {
      return routeHasMaterial(this, material, route);
    };

    proto.materialCompatible = function (material) {
      return this.hasRouteVariants(material, this.sizeFilter);
    };

    proto.paperFinishOptions = function () {
      if (this.material && this.material.paperFinish) return [{ label: this.material.paperFinish, note: this.material.note || this.material.label }];
      if (this.material && this.material.stockOnly) return [];
      return originalPaperFinishOptions ? originalPaperFinishOptions.call(this) : [];
    };

    if (originalCompatibleMaterials) {
      proto.compatibleMaterials = function () {
        this.ensureFineArtMaterial();
        if (this.sizeFilter) {
          var list = this.materials.filter(function (material) { return this.materialCompatible(material); }, this);
          return list.length ? list : this.materials;
        }
        return originalCompatibleMaterials.call(this);
      };
    }

    if (originalApplySizeFilterDefaults) {
      proto.applySizeFilterDefaults = function () {
        this.ensureFineArtMaterial();
        return originalApplySizeFilterDefaults.call(this);
      };
    }

    if (originalInstallSizeFilter) {
      proto.installSizeFilter = function () {
        this.ensureFineArtMaterial();
        return originalInstallSizeFilter.call(this);
      };
    }

    if (originalRenderMaterials) {
      proto.renderMaterials = function () {
        this.ensureFineArtMaterial();
        return originalRenderMaterials.call(this);
      };
    }
  }

  function refreshFineArtMaterials() {
    document.querySelectorAll("print-frame-studio").forEach(function (studio) {
      if (typeof studio.ensureFineArtMaterial === "function") studio.ensureFineArtMaterial();
      if (typeof studio.applySizeFilterDefaults === "function") studio.applySizeFilterDefaults();
      if (typeof studio.renderSizeFilters === "function") studio.renderSizeFilters();
      if (typeof studio.renderMaterials === "function") studio.renderMaterials();
      if (typeof studio.renderSizes === "function") studio.renderSizes();
      if (typeof studio.renderFinishOptions === "function") studio.renderFinishOptions();
      if (typeof studio.sync === "function") studio.sync();
    });
  }

  var PRINTS_AND_PRODUCTS_URL = "https://www.905print.com/pages/prints-and-products";

  function viewProductsButtonText(element) {
    return (element.textContent || "").replace(/\s+/g, " ").trim().toLowerCase();
  }

  function bindViewProductsRedirect(element) {
    if (!element || !element.dataset || element.dataset.printsProductsRedirectBound === "true") return;
    var text = viewProductsButtonText(element);
    if (text !== "view products" && text !== "view product") return;

    element.dataset.printsProductsRedirectBound = "true";
    if (element.tagName && element.tagName.toLowerCase() === "a") {
      element.setAttribute("href", PRINTS_AND_PRODUCTS_URL);
    }

    element.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.href = PRINTS_AND_PRODUCTS_URL;
    }, true);
  }

  function updateViewProductsRedirects(root) {
    if (!root || !root.querySelectorAll) return;
    if (root.matches && (root.matches("a") || root.matches("button"))) bindViewProductsRedirect(root);
    Array.prototype.forEach.call(root.querySelectorAll("a, button"), bindViewProductsRedirect);
  }

  function watchViewProductsRedirects() {
    updateViewProductsRedirects(document);
    ["product-form:submit:success", "ajaxProduct:added", "cart:updated", "cart:open", "drawerOpen"].forEach(function (eventName) {
      document.addEventListener(eventName, function () {
        window.setTimeout(function () {
          updateViewProductsRedirects(document);
        }, 0);
        window.setTimeout(function () {
          updateViewProductsRedirects(document);
        }, 250);
      });
    });

    if (!window.MutationObserver || !document.body) return;
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes, function (node) {
          if (node.nodeType === 1) updateViewProductsRedirects(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  ready(watchViewProductsRedirects);

  if (window.customElements) {
    customElements.whenDefined("print-frame-studio").then(function () {
      patchPrintStudio();
      document.querySelectorAll("print-frame-studio").forEach(function (studio) {
        if (studio.installSizeFilter) studio.installSizeFilter();
      });
    });
  }
})();
